import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Card } from "semantic-ui-react";
import { DispatchType } from "../../lib/rxMode/IRxBoxAppState";
import { setRxWarningHeight } from "../../lib/store/reducers/layoutHelperReducer";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import "./RxOrderComments.css";

const RxOrderWarnings = (props: any) => {
  const {
    warningMessages
  }: { warningMessages: string[] } = props;
  const container: React.RefObject<HTMLDivElement> = useRef(null);
  useEffect(() => {
     let currentHeight = container?.current?.clientHeight;
     if (currentHeight != null) props.setHeight(currentHeight);
  });

  if (!warningMessages?.length || warningMessages?.length == 0) {
    return null;
  }

  var warningCards = warningMessages.map((warningMessage, index) => {
    return (
      <div className="order-comment-card" key={index}>
        <div >
          <span>
            {warningMessage}
          </span><br />
          <div style={{ clear: "both" }}></div>
        </div>
      </div>
    )
  });

  return (
    <div ref={container}>
      <div className="warning-list flexColumn">
        <Card className="warning-card">
          <Card.Content >
            <Card.Header >Varningsmeddelanden</Card.Header>
            {warningCards}
          </Card.Content>
        </Card>
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch: DispatchType) => {
  return {
    setHeight: (height: number) => dispatch(setRxWarningHeight(new PayloadWrapper(height)))
  };
};


export default connect(null, mapDispatchToProps)(RxOrderWarnings);
